import { Section } from '../layout/Section'
import { Button } from '../ui/Button'
import { MessageCircle, Mail, ArrowRight } from 'lucide-react'
import { trackExternalLink } from '../../lib/firebase'

export function Contact() {
    return (
        <Section id="contato" background="gradient">
            <div className="grid lg:grid-cols-2 gap-12 items-start">
                {/* Text Content */}
                <div className="text-center lg:text-left">
                    {/* Headline */}
                    <h2 className="text-3xl md:text-4xl font-bold mb-6">
                        Vamos construir a sua próxima grande conquista?
                    </h2>

                    <p className="text-xl text-white/80 mb-10">
                        Transforme sua TI de centro de custo em uma aliada estratégica do negócio.
                    </p>

                    {/* Contact Options */}
                    <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-8">
                        <Button
                            href="https://wa.me/5521991937869?text=Olá! Gostaria de saber mais sobre os serviços da DPXP."
                            variant="primary"
                            size="lg"
                            className="bg-[#25D366] text-white hover:bg-[#1da851]"
                            onClick={() => trackExternalLink('whatsapp', 'wa.me', 'contact')}
                        >
                            <MessageCircle className="w-5 h-5 mr-2" />
                            WhatsApp
                        </Button>

                        <Button
                            href="mailto:contato@dpxp.io"
                            variant="ghost"
                            size="lg"
                            className="border-2 border-white text-white hover:bg-white/20"
                            onClick={() => trackExternalLink('email', 'contato', 'contact')}
                        >
                            <Mail className="w-5 h-5 mr-2" />
                            E-mail
                        </Button>
                    </div>

                    {/* Response time */}
                    <div className="flex items-center justify-center lg:justify-start text-white/70">
                        <ArrowRight className="w-5 h-5 mr-2" />
                        <span className="text-sm">Resposta em até 24 horas úteis</span>
                    </div>
                </div>

                {/* Commitment Card + Image Composition */}
                <div>
                    {/* Image composition: celular base + plug-celular overlay */}
                    {/* Imagem menor para não empurrar conteúdo */}
                    <div className="hidden lg:flex justify-center mb-6">
                        <div className="relative w-full max-w-xs">
                            {/* Base: smartphone/celular */}
                            <img
                                src="/assets/smartphone-dashboard-analytics-metricas-performance-alinhado-esquerda-celular.svg"
                                alt="Interface de dashboard"
                                className="w-full h-auto"
                            />
                            {/* Overlay: equipe plug-celular */}
                            <img
                                src="/assets/equipe-analise-pesquisa-lupa-engrenagens-alinhado-esquerda-plug-celular.svg"
                                alt="Equipe de análise"
                                className="absolute w-full h-auto"
                                style={{
                                    top: '25%',
                                    left: '0%',
                                    transform: 'scale(1)',
                                }}
                            />
                        </div>
                    </div>

                    {/* Commitment Statement */}
                    <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
                        <h3 className="text-2xl font-semibold mb-4">Nosso Compromisso</h3>
                        <p className="text-white/90 leading-relaxed">
                            Não vendemos sonhos distantes. Caminhamos ao seu lado, garantindo firmeza em cada decisão para entregar a realidade que a sua empresa precisa e merece.
                            Nossa equipe está pronta para entender seu cenário e propor soluções personalizadas.
                        </p>
                    </div>
                </div>
            </div>
        </Section>
    )
}
